/** The built-in themes (D-146). Admin-made custom themes (D-047) were retired in D-184. */
import { isBuiltinTheme } from "@digu/shared";

/**
 * D-204: "Automatic" is DIGU Classic in the device's own mode: Classic light when the phone is set to light, Classic
 * (dark) otherwise. (Before D-204 it was Sea glass by day and Ink by night, by the clock.)
 */
export const AUTO_THEME = "auto";
export const LIGHT_QUERY = "(prefers-color-scheme: light)";
export function autoTheme(light: boolean): "classic-light" | "classic" { return light ? "classic-light" : "classic"; }
/** Whether the device asks for a light look right now. */
export function systemLight(): boolean { return typeof window !== "undefined" && !!window.matchMedia?.(LIGHT_QUERY).matches; }
/** The theme id that `pref` means right now ("auto" follows the device; anything else is itself). */
export function resolveTheme(pref: string, light: boolean = systemLight()): string { return pref === AUTO_THEME ? autoTheme(light) : pref; }
/** Themes with a light page (occasion looks pick their light set over these). */
export const LIGHT_THEMES: ReadonlySet<string> = new Set(["classic-light", "seaglass", "reed"]);

/** Applies a built-in theme id or "auto"; anything else (a retired custom theme, D-184) shows DIGU Classic. */
export function applyThemeId(pref: string): void {
  if (typeof document === "undefined") return;
  const id = resolveTheme(pref);
  document.documentElement.dataset.theme = isBuiltinTheme(id) ? id : "classic";
}
